import { makeStyles, List, ListItem, Box, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { COLORS } from '../shared/Theme';
import { TitleBackBar2 } from '../shared/header/TitleBar';

const useStyles = makeStyles((theme) => ({
	box: {
		marginTop: '2vh',
		[theme.breakpoints.up('md')]: {
			marginTop: '0px',
		},
	},
	list: {
		padding: 0,
		width: '100vw',
		//margin: '3vw',
		height: '73vh',
		overflowY: 'auto',
		...theme.typography.subtitle1,
		color: `${COLORS.BROWNISH_GREY}`,
		[theme.breakpoints.up('md')]: {
			height: '100%',
			...theme.typography.subtitle1,
		},
	},
	listItem: {
		borderRadius: 5,
		border: 'solid 1px #d3d3d3',
		boxShadow: '1px 0px 6px 0 rgba(0, 0, 0, 0.16)',

		width: '94%',
		margin: '3vw',
		paddingLeft: '2.5vw',
		paddingRight: '2.5vw',
		paddingTop: '2.2vh',
		paddingBottom: '2.2vh',
	},
	manualSize: {
		width: '60vw',
		heigth: '6vh',
		//marginLeft: '14.5vw',
		marginBottom: '1vh',
		marginTop: '1vh',
	},
	toastSize: {
		width: '60vw',
		heigth: '6vh',
		//marginLeft: '14.5vw',
		marginBottom: '1vh',
		marginTop: '1vh',
	},
	whiteSize: {
		width: '50%',
		border: '0.5px solid',
		marginTop: '0.5vh',
		marginBottom: '0.5vh',
	},
	translateSize: {
		width: '100%',
		border: '0.5px solid',
		marginTop: '0.5vh',
		marginBottom: '0.5vh',
	},
	translateZoomSize: {
		width: '100%',
		border: '0.5px solid',
		marginTop: '0.5vh',
		marginBottom: '0.5vh',
	},

	logoSection: {
		display: 'flex',
		flex: 1,
		width: '100%',
		alignItems: 'flex-end',
		paddingBottom: '5vh',
	},
	logo: {
		width: '5.5vw',
		maxWidth: '35px',
	},
}));

const QnA: React.FC<any> = (props) => {
	const classes = useStyles();
	let history = useHistory();

	const { t } = useTranslation('common');

	return (
		<>
			<TitleBackBar2 history={history} title="QnA" titleIcon="question" />

			<Box className={classes.box} display="grid" justifyContent="center" alignItems="center">
				<List className={classes.list}>
					<ListItem className={classes.listItem}>
						<Typography variant="subtitle1">
							{t('QnA.intro1')}
							<br />
							{t('QnA.intro2')}
						</Typography>
					</ListItem>
					<ListItem className={classes.listItem}>
						<details>
							<summary>{t('QnA.summaryManuTitle')}</summary>
							<Typography>
								<br />
								{t('QnA.manuStep1')}
								<br />
								<img className={classes.manualSize} src="/images/qna/manual_man1.png" />
								<br />
								{t('QnA.manuStep2')}
								<br />
								<img className={classes.manualSize} src="/images/qna/manual_man2.png" />
								<br />
								{t('QnA.manuStep3')}
								<br />
								<img className={classes.manualSize} src="/images/qna/manual_man3.png" />
								<br />
								{t('QnA.manuStep4')}
								<br />
								<img className={classes.manualSize} src="/images/qna/manual_man4.png" />
								<br />
								{t('QnA.manuEnd')}
							</Typography>
						</details>
					</ListItem>
					<ListItem className={classes.listItem}>
						<details>
							<summary>{t('QnA.summaryDistTitle')}</summary>
							<Typography>
								<br />
								{t('QnA.distStep1')}
								<br />
								{t('QnA.distStep2')}
								<br />
								<img className={classes.manualSize} src="/images/qna/manual_dis1.png" />
								<br />
								{t('QnA.distStep3')}
								<br />
								<img className={classes.manualSize} src="/images/qna/manual_dis2.png" />
								<br />
								{t('QnA.distStep4')}
								<br />
								<img className={classes.manualSize} src="/images/qna/manual_dis3.png" />
								<br />
								{t('QnA.distEnd')}
							</Typography>
						</details>
					</ListItem>
					<ListItem className={classes.listItem}>
						<details>
							<summary>{t('QnA.summaryToastTitle')}</summary>
							<Typography>
								<img className={classes.toastSize} src="/images/qna/toast_success.png" />
								<br />
								{t('QnA.toastGreen')}
								<br />
								<img className={classes.toastSize} src="/images/qna/toast_warning.png" />
								<br />
								{t('QnA.toastOrange')}
								<br />
								{t('QnA.toastExamplePrefix')}
								{t('QnA.toastExample')}
								<br />
								<img className={classes.toastSize} src="/images/qna/toast_error.png" />
								<br />
								{t('QnA.toastRed')}
								<br />
								{t('QnA.toastRetry')}
								<br />
							</Typography>
						</details>
					</ListItem>
					<ListItem className={classes.listItem}>
						<details>
							<summary>{t('QnA.summaryWhiteTitle')}</summary>
							<Typography>
								<img className={classes.whiteSize} src="/images/qna/white_page.png" />
								<div>{t('QnA.whitePageDesc')}</div>
							</Typography>
						</details>
					</ListItem>
					{/* <ListItem className={classes.listItem}>
						<details>
							<summary>한글이 이상하게 떠요</summary>
							<Typography>
								<img className={classes.translateSize} src="/images/qna/translate_error.png" />
								<img className={classes.translateZoomSize} src="/images/qna/translate_error_zoom.png" />
								<div>1. 웹사이트 주소 옆의 번역 표시를 눌러주세요.</div>
								<div>2. 한글에서 영어로 번역을 변경해주세요.</div>
								<div>* 어디서 이상하게 보이는지 선생님께 알려줘요</div>
							</Typography>
						</details>
					</ListItem> */}
				</List>
			</Box>

			<div className={classes.logoSection}>
				<div style={{ flexDirection: 'column', width: '100vw' }}>
					<div style={{ textAlign: 'center', marginLeft: 'auto' }}>
						<img className={classes.logo} src="/images/p.webp" />
					</div>
				</div>
			</div>
		</>
	);
};

export default QnA;
